/** Helpers for transfer Items tab (on-hand pick + qty cap). */

export interface OnHandItem {
  itemName: string;
  type?: string;
  quantity: number;
  unit: string;
}

export function isKegPackage(line: { packageType?: string | null; itemName?: string | null }) {
  const s = String(line.packageType || line.itemName || '');
  return /keg/i.test(s) && !/shell/i.test(s);
}

export function availableForItem(onHand: OnHandItem[], itemName: string): number {
  const hit = onHand.find((i) => i.itemName === itemName);
  return hit ? Number(hit.quantity) || 0 : 0;
}

export function capQty(qty: number, max: number): number {
  if (!Number.isFinite(qty) || qty < 0) return 0;
  if (!Number.isFinite(max)) return qty;
  return Math.min(qty, max);
}

/** Positive on-hand rows only (for searchable item dropdown). */
export function positiveOnHand(items: OnHandItem[]): OnHandItem[] {
  return (items || []).filter((i) => Number(i.quantity) > 0);
}
